import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: 'Wirkt das wirklich so schnell?',
    answer: 'JA. 87% unserer Kundinnen berichten von ersten sichtbaren Veränderungen innerhalb von 7-14 Tagen. Nach 8 Wochen sind die Ergebnisse dramatisch.'
  }, {
    question: 'Ist das nicht zu gut, um wahr zu sein?',
    answer: 'Wir verstehen Ihre Skepsis. Deshalb haben wir 37 klinische Studien durchführen lassen. Die Zahlen lügen nicht: +20,2% Muskelaufbau, +40% Sättigung, 94% Zufriedenheit.'
  }, {
    question: 'Was, wenn es bei mir nicht wirkt?',
    answer: 'Dann bekommen Sie Ihr Geld zurück. Ohne Diskussion. Wir tragen das Risiko, nicht Sie. 30 Tage Geld-zurück-Garantie.'
  }, {
    question: 'Warum ist es gerade so günstig?',
    answer: 'Dies ist ein zeitlich begrenztes Leserangebot. Wir wollen, dass mehr Frauen eve ausprobieren. Sobald diese Charge ausverkauft ist, endet das Angebot.'
  }, {
    question: 'Wie bereite ich den Shake zu?',
    answer: 'Einfach 30g Pulver (ca. 2 Messlöffel) mit 250-300ml Wasser oder pflanzlicher Milch im Shaker mischen. Fertig in nur 30 Sekunden!'
  }, {
    question: 'Proteinshakes haben mir noch nie geschmeckt... Wie schmeckt eve?',
    answer: 'eve nutrition schmeckt dank natürlicher Zutaten und echter Vanille besonders cremig und angenehm - ohne den typischen künstlichen Nachgeschmack vieler Proteinshakes.'
  }, {
    question: 'Kann ich den Shake auch mit Milchalternativen zubereiten?',
    answer: 'Ja, der Shake kann perfekt mit Mandel-, Hafer-, Soja- oder Kokosmilch zubereitet werden. Das gibt zusätzliche Geschmacksvarianten!'
  }];
  const [openIndex, setOpenIndex] = useState(0);
  const toggleFaq = (index: number) => {
    if (openIndex === index) {
      setOpenIndex(-1);
    } else {
      setOpenIndex(index);
    }
  };
  return <section className="py-16 bg-gray-50" data-id="element-75">
      <div className="max-w-4xl mx-auto" data-id="element-76">
        <div className="text-center mb-12" data-id="element-77">
          <span className="inline-block bg-emerald-100 text-emerald-700 text-sm font-medium py-1 px-3 rounded-full mb-3" data-id="element-78">
            FAQ
          </span>
          <h3 className="text-4xl font-bold text-gray-800" data-id="element-79">
            Häufig gestellte Fragen
          </h3>
        </div>
        <div className="space-y-4 bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-80">
          {faqs.map((faq, index) => <div key={index} className={`border ${openIndex === index ? 'border-emerald-200' : 'border-gray-200'} rounded-lg overflow-hidden transition-colors duration-300`} data-id="element-81">
              <button className={`w-full flex justify-between items-center p-5 text-left focus:outline-none ${openIndex === index ? 'bg-emerald-50' : 'bg-white'}`} onClick={() => toggleFaq(index)} data-id="element-82">
                <span className={`font-medium ${openIndex === index ? 'text-emerald-700' : 'text-gray-800'}`} data-id="element-83">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUpIcon className="h-5 w-5 text-emerald-600 flex-shrink-0" data-id="element-84" /> : <ChevronDownIcon className="h-5 w-5 text-emerald-600 flex-shrink-0" data-id="element-85" />}
              </button>
              {openIndex === index && <div className="p-5 bg-white border-t border-gray-200" data-id="element-86">
                  <p className="text-gray-700 leading-relaxed" data-id="element-87">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
        <div className="mt-12 bg-red-50 border-2 border-red-200 rounded-xl p-8 text-center" data-id="element-88">
          <h4 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-89">
            ⏰ LETZTE CHANCE: Nur noch 247 Pakete verfügbar
          </h4>
          <p className="text-gray-700 mb-6" data-id="element-90">
            Über 823 Frauen haben in den letzten 24 Stunden bestellt. Der Vorrat
            geht zu Ende.
          </p>
          <div className="mb-6" data-id="element-91">
            <p className="text-gray-700 font-medium mb-2" data-id="element-92">
              Wenn Sie jetzt nicht bestellen, verpassen Sie:
            </p>
            <ul className="text-left max-w-md mx-auto space-y-2" data-id="element-93">
              <li className="text-gray-700" data-id="element-94">❌ Bis zu 45% Rabatt</li>
              <li className="text-gray-700" data-id="element-95">❌ GRATIS Versand</li>
              <li className="text-gray-700" data-id="element-96">
                ❌ Die Chance auf sichtbare Ergebnisse in 14 Tagen
              </li>
            </ul>
          </div>
          <a href="https://weesesumecontasy.com/click/2" className="inline-block" data-id="element-97">
            <button className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-4 px-10 rounded-full transition duration-300 shadow-md text-lg" data-id="element-98">
              JETZT RISIKOFREI BESTELLEN
            </button>
          </a>
        </div>
        <div className="mt-12 p-6 bg-gray-100 rounded-xl border border-gray-200" data-id="element-99">
          <h4 className="font-medium text-gray-800 mb-2" data-id="element-100">Disclaimer</h4>
          <p className="text-sm text-gray-600 leading-relaxed" data-id="element-101">
            Diese Website dient der Bewertung und Information zu verschiedenen
            Marken und Unternehmen. Die Bewertungen basieren auf dem Ermessen
            unserer Autoren und sollten nicht als Ersatz für einen gesunden
            Lebensstil oder eine ausgewogene und abwechslungsreiche Ernährung
            betrachtet werden. Die Ergebnisse können von Person zu Person
            unterschiedlich sein und werden nicht garantiert. Bei
            gesundheitlichen Fragen (vor allem in Schwangerschaft, Stillzeit
            oder bei Vorerkrankungen) sollten Sie ärztliche Beratung einholen.
          </p>
        </div>
      </div>
    </section>;
}